module.exports = __webpack_public_path__ + "img/registration-success.06a738e2.webp";